// extracted by mini-css-extract-plugin
module.exports = {"body":"Layout_body__spyPY","content":"Layout_content__8e2nl","limitWidth":"Layout_limitWidth__c7219"};